import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ITicketResponse } from '../ticket-response';
import { ticketResponseSchema } from '../ticket-response';

export async function getTicketApi(id: number): Promise<IValidatedResponse<ITicketResponse>> {
  return getRequest<ITicketResponse>({
    path: `/ticket/${id}`,
    schema: ticketResponseSchema,
  });
}
